import './NoMatch.css'
import React from 'react'
import img404 from './assets/404.svg'

const NoMatch = ({ location }) => {
  return (
    <div className='NoMatch'>
      <img src={img404} role='presentation' />
      <h2>Looks like you done got lost M8...</h2>
      <p>Sorry but <code>{location.pathname}</code> didn’t match any pages</p>
    </div>
  )
}

export default NoMatch



// WEBPACK FOOTER //
// ./src/NoMatch.js